<template>
  <div>
    <CalendarPicker
      v-if="showCalendar"
      class="maincalendar"
      :monthmode="isMonth"
      @date-selected="setData"
      @close-picker="showCalendar = false" />
    <div class="inputgrid">
      <DateInputButton
        :isMonth="isMonth"
        :lang="lang"
        :selectedDates="selectedDates"
        @click="showCalendar = true" />
    </div> 
  </div>
</template>

<script>
import DateInputButton from "@/components/dateInputButton.vue";
import CalendarPicker from '@/containers/mobile/CalendarPicker.vue';
import { i18n } from '@/main.js';

export default {
  name: 'FormDateInput',
  props:["label","modelValue","isMonth"],
  emits:["setData","update:modelValue"],
  components:{
    DateInputButton,
    CalendarPicker
  },
  data() {
    return {
      showCalendar: false,
      selectedDates: null
    }
  },
  created(){
    this.selectedDates = this.modelValue;
  },
  computed:{
    lang(){
      const lg = i18n.global.locale == "pt" ? "pt-PT" : "en-EN"
      return lg;
    }
  },
  watch: {
    'modelValue': function(newVal, oldVal) {
      this.selectedDates = newVal
    },
  },
  methods: {
    setData(data){
      this.selectedDates = data;
      this.showCalendar = false;
      this.$emit('update:modelValue', data);
    },
  }
}
</script>

<style scoped>
@media only screen and (max-width: 767px) {
  .inputgrid{
    grid-template-columns: 1fr;
  }

  .maincalendar{
    position: fixed;
    top:0;
    left: 0;
    right: 0;
  }
}
</style>